﻿<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum rozhodnutí o zastavení</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.cadastreEntryStoppedDate" [maxToday]="true"/></div>
  </div>
</fieldset>
